import type { ComponentProps } from 'react';
type Props = {
  variant?: 'muted' | 'active' | 'primary' | 'fill';
} & ComponentProps<'svg'>;
export const PeopleIcon = ({
  variant = 'primary',
  ...rest
}: Props) => {
  switch (variant) {
    case 'muted':
      return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...rest}>
          <g className="color=muted">
            <g className="Group">
              <path fill="#646467" d="M11 9.88C11 11.262 9.88 12 8.5 12S6 11.261 6 9.88C6 8.5 7.12 7 8.5 7S11 8.5 11 9.88Zm-7.5 6.37c0 2.75 0 2.75 5 2.75s5 0 5-2.75-2.239-2.75-5-2.75-5 0-5 2.75Z" className="Vector" />
              <path fill="#646467" d="M14 9.88c0 1.381 1.12 2.12 2.5 2.12s2.5-.739 2.5-2.12C19 8.5 17.88 7 16.5 7S14 8.5 14 9.88Zm-.187 9.088c.687-.52.687-1.38.687-2.768 0-1.188-.393-1.977-1.067-2.498.847-.202 1.911-.202 3.067-.202 2.761 0 5 0 5 2.75 0 1.105 0 1.765-.324 2.16-.483.59-1.684.59-4.676.59-1.133 0-2.01 0-2.687-.032Z" className="active" />
            </g>
          </g>
        </svg>;
    case 'active':
      return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...rest}>
          <g className="color=active">
            <g className="Group">
              <path fill="#646467" d="M11 9.88C11 11.262 9.88 12 8.5 12S6 11.261 6 9.88C6 8.5 7.12 7 8.5 7S11 8.5 11 9.88Zm-7.5 6.37c0 2.75 0 2.75 5 2.75s5 0 5-2.75-2.239-2.75-5-2.75-5 0-5 2.75Z" className="Vector" />
              <path fill="#546195" d="M14 9.88c0 1.381 1.12 2.12 2.5 2.12s2.5-.739 2.5-2.12C19 8.5 17.88 7 16.5 7S14 8.5 14 9.88Zm-.187 9.088c.687-.52.687-1.38.687-2.768 0-1.188-.393-1.977-1.067-2.498.847-.202 1.911-.202 3.067-.202 2.761 0 5 0 5 2.75 0 1.105 0 1.765-.324 2.16-.483.59-1.684.59-4.676.59-1.133 0-2.01 0-2.687-.032Z" className="active" />
            </g>
          </g>
        </svg>;
    case 'primary':
      return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...rest}>
          <g className="color=primary">
            <g className="Group">
              <path fill="#1D2445" d="M11 9.88C11 11.262 9.88 12 8.5 12S6 11.261 6 9.88C6 8.5 7.12 7 8.5 7S11 8.5 11 9.88Zm-7.5 6.37c0 2.75 0 2.75 5 2.75s5 0 5-2.75-2.239-2.75-5-2.75-5 0-5 2.75Z" className="Vector" />
              <path fill="#1D2445" d="M14 9.88c0 1.381 1.12 2.12 2.5 2.12s2.5-.739 2.5-2.12C19 8.5 17.88 7 16.5 7S14 8.5 14 9.88Zm-.187 9.088c.687-.52.687-1.38.687-2.768 0-1.188-.393-1.977-1.067-2.498.847-.202 1.911-.202 3.067-.202 2.761 0 5 0 5 2.75 0 1.105 0 1.765-.324 2.16-.483.59-1.684.59-4.676.59-1.133 0-2.01 0-2.687-.032Z" className="active" />
            </g>
          </g>
        </svg>;
    case 'fill':
      return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...rest}>
          <g className="color=primary on fill">
            <g className="Group">
              <path fill="#fff" d="M11 9.88C11 11.262 9.88 12 8.5 12S6 11.261 6 9.88C6 8.5 7.12 7 8.5 7S11 8.5 11 9.88Zm-7.5 6.37c0 2.75 0 2.75 5 2.75s5 0 5-2.75-2.239-2.75-5-2.75-5 0-5 2.75Z" className="Vector" />
              <path fill="#fff" d="M14 9.88c0 1.381 1.12 2.12 2.5 2.12s2.5-.739 2.5-2.12C19 8.5 17.88 7 16.5 7S14 8.5 14 9.88Zm-.187 9.088c.687-.52.687-1.38.687-2.768 0-1.188-.393-1.977-1.067-2.498.847-.202 1.911-.202 3.067-.202 2.761 0 5 0 5 2.75 0 1.105 0 1.765-.324 2.16-.483.59-1.684.59-4.676.59-1.133 0-2.01 0-2.687-.032Z" className="active" />
            </g>
          </g>
        </svg>;
  }
};